const URLS = {
  home: "home",
  about: "about",
  architecture: "architecture",
  engineering: "engineering",
  contact: "contact",
};

export default URLS;
